import { keyframes } from '@mui/system';

export const boxShadow = 'box-shadow 0.5s 0.05s';

const spread = '8px';
const blur = '25px';

export const spreadHover = '12px';
export const blurHover = '40px';

export const shadowOpacity = 0.4;

export const boxShadowTransition = `${boxShadow} 0.5s 0.05s`;

export const lightPeachShadow = {
  transition: boxShadowTransition,
  boxShadow: `0 0 ${blur} ${spread} rgba(250, 203, 188, ${shadowOpacity})`,
  '&:hover': {
    boxShadow: `0 0 ${blurHover} ${spreadHover} rgba(250, 203, 188, ${shadowOpacity})`,
  },
};

export const tealShadow = {
  transition: boxShadowTransition,
  boxShadow: `0 0 ${blur} ${spread} rgba(170, 229, 243, ${shadowOpacity})`,
  '&:hover': {
    boxShadow: `0 0 ${blurHover} ${spreadHover} rgba(170, 229, 243, ${shadowOpacity})`,
  },
};

export const pinkShadow = {
  transition: boxShadowTransition,
  boxShadow: `0 0 ${blur} ${spread} rgba(247, 179, 188, ${shadowOpacity})`,
  '&:hover': {
    boxShadow: `0 0 ${blurHover} ${spreadHover} rgba(247, 179, 188, ${shadowOpacity})`,
  },
};

export const createFadeSlideKeyframes = (timing = 0) => keyframes`
0% {
  opacity: 0;
}
${20 + timing * 5}% {
  opacity: 0;
}
100% {
  opacity: unset;
}
`;

export const createFadeSlideAnimation = (timing = 0) => `${createFadeSlideKeyframes(timing)} 1s ease-in`;

export const RotateAnimation = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;

export const OpacityAnimation = keyframes`
from {
  opacity: 0.5;
}
50% {
  opacity: 0.8;
}
to {
  opacity: 0.5;
}
`;
